import FileDownload from 'js-file-download';
import toastrError from 'src/helpers/toastr/toastrError';
import communicate from 'src/api/communicate';

export const EXCEL_SUCCESS = 'LOAD_EXCEL_SUCCESS';
export const EXCEL_FAIL = 'LOAD_EXCEL_FAIL';
export const EXCEL_REQUEST = 'LOAD_EXCEL_REQUEST';

export const loadExcelRequest = () => ({ type: EXCEL_REQUEST });
export const loadExcelFail = (error) => ({ type: EXCEL_FAIL, error });
export const loadExcelSuccess = () => ({ type: EXCEL_SUCCESS });

export const loadExcelExport = (request) => (dispatch) => {
  dispatch(loadExcelRequest());
  return communicate({
    url: request.url, method: 'get', getParams: request.query, responseType: 'blob'
  }).then((response) => {
    dispatch(loadExcelSuccess());
    const fileName = response.headers['x-suggested-filename'] || 'Raport.xlsx';
    FileDownload(response.data, fileName);
  }).catch((error) => {
    toastrError(error);
    dispatch(loadExcelFail(error));
  });
};
